import {
  ParamsGetConsolidateRevenueType,
  ParamsGetServicesReportType
} from 'services/api/type/report.type';
import { useQuery } from '@tanstack/react-query';
import API from 'services/api/index';
import QUERY_KEYS from 'services/api/queryKeys';
import _ from 'lodash';
import { PaginationType } from 'services/api/type/booking.type';
import { PAGE_SIZE_CONSOLIDATE_SOURCE_DETAILS } from 'services/api/module/report.api';
import { trimTruthyValues } from 'utils';

export const useGetConsolidateRevenue = (
  filterOptions: ParamsGetConsolidateRevenueType,
  isEnable: boolean = true
) => {
  const { data, isLoading } = useQuery({
    queryKey: [QUERY_KEYS.GET_CONSOLIDATE_REVENUE, filterOptions],
    queryFn: () => API.report.getConsolidateRevenue(filterOptions),
    enabled: isEnable
  });

  return {
    data: data ?? null, // Ensure `null` for unavailable data, not an empty array
    isLoading
  };
};

export const useGetConsolidateSourceRevenue = (
  filterOptions: ParamsGetConsolidateRevenueType,
  isEnable: boolean = true,
  branch_ids: string | undefined
) => {
  const { data, isFetching, isLoading } = useQuery({
    queryKey: [QUERY_KEYS.GET_CONSOLIDATE_SOURCE_REVENUE, filterOptions, branch_ids],
    queryFn: () => API.report.getConsolidateSourceRevenue(filterOptions, branch_ids),
    enabled: isEnable
  });
  return {
    data: data ?? null,
    isFetching,
    isLoading
  };
};

export const useGetConsolidateCampaignRevenue = (
  filterOptions: ParamsGetConsolidateRevenueType,
  isEnable: boolean = true
) => {
  const { data, isLoading } = useQuery({
    queryKey: [QUERY_KEYS.GET_CONSOLIDATE_CAMPAIGN_REVENUE, filterOptions],
    queryFn: () => API.report.getConsolidateCampaignRevenue(filterOptions),
    enabled: isEnable
  });

  return {
    data: data ?? null, // Ensure `null` for unavailable data, not an empty array
    isLoading
  };
};

export const useGetConsolidateSourceRevenueDetails = (
  filerOptions: ParamsGetConsolidateRevenueType,
  page: number,
  pageSize: number = PAGE_SIZE_CONSOLIDATE_SOURCE_DETAILS,
  isEnabled: boolean = true
) => {
  const { data, isLoading } = useQuery({
    queryKey: [
      QUERY_KEYS.GET_CONSOLIDATE_SOURCE_REVENUE,
      page,
      filerOptions.source_id,
      filerOptions.branch_ids
    ],
    queryFn: () => API.report.getConsolidateSourceRevenueDetails(filerOptions, page, pageSize),
    enabled: !!filerOptions.source_id && isEnabled,
    staleTime: 5000
  });
  return {
    data: _.get(data, 'data', []),
    pagination: _.get(data, 'pagination', {}) as PaginationType,
    isLoading
  };
};

export const useGetServicesReport = (
  filterOptions: ParamsGetServicesReportType,
  page: number,
  pageSize: number = PAGE_SIZE_CONSOLIDATE_SOURCE_DETAILS,
  isEnable: boolean = true
) => {
  const truthyFilterOptions = trimTruthyValues(filterOptions);
  console.log('truthyFilterOptions1', truthyFilterOptions);

  const { data, isLoading } = useQuery({
    queryKey: [
      QUERY_KEYS.GET_SERVICES_REPORT,
      truthyFilterOptions,
      page,
      pageSize,
      truthyFilterOptions.branch_ids
    ],
    queryFn: () => API.report.getServicesReport(truthyFilterOptions, page, pageSize),
    enabled: isEnable
  });
  return {
    data: _.get(data, 'data', []),
    pagination: _.get(data, 'pagination', {}) as PaginationType,
    isLoading
  };
};

export const useGetServicesReportNoPagination = (
  filterOptions: ParamsGetServicesReportType,
  isEnable: boolean = true
) => {
  const truthyFilterOptions = trimTruthyValues(filterOptions);
  console.log('truthyFilterOptions2', truthyFilterOptions);
  const { data, isLoading } = useQuery({
    queryKey: [
      QUERY_KEYS.GET_SERVICES_REPORT_NO_PAGINATION,
      truthyFilterOptions,
      truthyFilterOptions.branch_ids,
      isEnable
    ],
    queryFn: () => API.report.getServicesReportNoPagination(truthyFilterOptions),
    enabled: isEnable
  });
  return {
    data: _.get(data, 'data', []),
    isLoading
  };
};
